import React, { useCallback, useEffect, useRef, useState } from 'react';
import { createContainer } from 'unstated-next';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { CallupHead, Player } from 'ThreeTerminal_mobile_dynamic';
import Footer from '@ifeng-fe/container_channel/common/client/components/footer/';
import { getSurveyData, getDocData, postSurveyData } from '../../../services/api';
import { formatImage } from '@ifeng-fe/public_method';
import useIntersect from './useIntersect';

/* eslint-disable */
const menu = allData.menu;
const PC = allData.pc;
/* eslint-disable */

const tabMenuIndex = [0, 6, 9]; // 主菜单对应子菜单开始索引

const styles = require(PC ? '../../../pc/vote/layout/index.module.css' : './index.module.css').default;

const headerConfig = {
    pageInfo: {
        type: 'web',
        id: location.href,
        kind: 'web',
        url: location.href,
        position: 1,
    },
    hotKeyword: [
        '这条最新发布的内容，80%的网友都在看',
        '热热热！这条精彩内容，你的朋友们都在看',
        '过去24小时发生了这些好玩的事，点击查看',
        '全网最热新闻出炉，这些事儿你都知道吗？',
        '想不到！今天最火爆的新闻居然是……',
        '这条重磅新闻刚刚发布！快来查看',
        '过去的24小时你错过了这些重要新闻……',
        '今天这条消息，90%的人都不知道！',
    ],
};

const votedRecord = {};

/**
 * 弹窗组件
 */
const useAlerter = function useAlerter() {
    let [data, setData] = useState(null);
    let toggle = (content = null) => {
        setData(content);
    };

    return [data, toggle];
};

export const Alerter = createContainer(useAlerter);

export const Alter = errorBoundary(() => {
    const [data, toggle] = Alerter.useContainer();

    useEffect(
        () => {
            if (data) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = 'auto';
            }
        },
        [data],
    );

    if (!data) return null;

    const Content =
        data.Component ||
        errorBoundary(({ toggle }) => {
            return (
                <div className={styles.box}>
                    <img
                        className={styles.close}
                        src={require('../assets/close.png')}
                        alt=""
                        onClick={() => toggle()}
                    />
                    <div className={styles.inner}>
                        {data.video && (
                            <div className={styles.video}>
                                <Player
                                    videoConfig={data.video}
                                    playermsg={{
                                        showPoster: true,
                                        showController: true,
                                    }}
                                />
                            </div>
                        )}
                        <div className={styles.content} dangerouslySetInnerHTML={{ __html: data.content }} />
                    </div>
                </div>
            );
        });

    return (
        <div className={styles.alert}>
            <div>
                <Content toggle={toggle} />
            </div>
        </div>
    );
});

const openAlert = async ({ id, title, toggle }) => {
    const { data } = await getDocData(id);
    // let content = data.contentList.content;
    let content = `
    <p>在品牌思维的影响下，文旅业开始从“产品”到“品牌”的转变，有的已经火出圈，在国内外都有自己的名片。有的还在蛰伏，但已完成前期的修炼。中国“文旅好品牌”，需要一次集结号。带着“守正创新、融通中外，传播文旅好品牌”的愿景，12月11日，2021第六届博鳌旅游传播论坛将在海南博鳌举办。</p>
    <br>
    <p>2021第六届博鳌旅游传播论坛由海南省旅游和文化广电体育厅主办，凤凰网、中国传媒大学广告学院承办，是2021年（第二十二届）海南国际旅游岛欢乐节琼海分会场主体活动之一，本次论坛共分两天，10日为集体签到日，11日为活动日。</p>
    <br>
    <p>11日上午将进行“文旅好品牌主场活动”，现场将发布2021“文旅好品牌”优质案例30强，以及部分优质案例的现场分享。11日下午为论坛时间，来自国内文化和旅游行业的众多知名专家、学者以及优秀的行业代表将共聚一堂，为大众带来一场场专业性和指向性十足的主题分享。</p>
    <br>
    <p>中国文物学会会长、原故宫博物院院长单霁翔，世界旅游经济论坛副主席兼秘书长何超琼（视频），中国旅游景区协会会长姚军，世界旅游城市联合会首席专家魏小安等业界知名人士，凤凰网总编辑邹明，中国传媒大学广告学院院长丁俊杰，文化和旅游部十四五规划专家委员会委员、北京交通大学现代旅游研究院院长张辉等组委会代表，海南省旅游和文化广电体育厅及欢乐节相关领导嘉宾、地方文旅厅局代表、三星堆博物馆等文博单位以及包括美团、锦江集团、携程、小红书在内的企业代表将出席活动。</p>
    <br>
    <p>从《文旅产业的品牌升级》、《文化遗产的超链接》，到《融通中外，文旅品牌的全球化表达》，再到《2021文旅传播十大趋势发布》，一个个议题都是当今以及未来中国文旅品牌必经的发展之路。</p>
    <br>
    <p>此次论坛将是站在产业顶层的一次高瞻远瞩，“对话美好，向好而生”。</p>
    `;

    let video = data.contentList.video;

    console.log(data.contentList.content);
    toggle({ title, content, video });
};

export const CallupHeader = errorBoundary(() => {
    return (
        <>
            {!PC && (
                <CallupHead
                    content={headerConfig}
                    closeCallback={() => {
                        this.setState({
                            scrollDirection: 'down',
                        });
                    }}
                />
            )}
        </>
    );
});

export const GotoTop = errorBoundary(() => {
    return (
        <img
            onClick={() => window.scrollTo(0, 0)}
            className={styles.goTop}
            src={require('../assets/goTop.png')}
            alt=""
        />
    );
});

const Layout = errorBoundary(props => {
    return (
        <Alerter.Provider>
            {!window.grounds && <CallupHeader />}
            <div className={styles.layout} id="layout">
                <Intro />
                <Content />
                <Alter />
                <GotoTop />
                {PC && (
                    <div className={styles.footer}>
                        <Footer content={props.content.footer} />
                    </div>
                )}
            </div>
        </Alerter.Provider>
    );
});

export default errorBoundary(Layout);

export const Intro = errorBoundary(() => {
    const id = '7zyeHDILX1c';
    const [doc, setDoc] = useState(async () => {
        const data = await getDocData(id);

        setDoc(data.data);
    });

    const [data, toggle] = Alerter.useContainer();

    return (
        <div className={styles.IntroBlock}>
            <div className={styles.desc}>
                {/* {doc?.summary || doc.title} */}
                中国“文旅好品牌”，需要一次集结号。带着“守正创新、融通中外，传播文旅好品牌”的愿景，12月11日，2021第六届博鳌旅游传播论坛将在海南博鳌举办。
                <div className={styles.descMask} />
            </div>
            <div className={styles.ckgdBox}>
                <div className={styles.btn} onClick={() => openAlert({ id, title: 'TC奖简介', toggle })}>
                    查看更多
                    <img src={require('../assets/ckgd.png')} alt="" />
                </div>
            </div>
        </div>
    );
});

const Menu = errorBoundary(({ index, setIndex, tab, activeMenu }) => {
    return (
        <div className={styles.menu}>
            {activeMenu.map((item, i) => {
                return (
                    <div
                        key={i}
                        onClick={e => {
                            e.target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                            setIndex(i + tabMenuIndex[tab]);
                        }}
                        className={`${styles.item} ${index === i + tabMenuIndex[tab] ? styles.active : null}`}>
                        {item.title}
                    </div>
                );
            })}
        </div>
    );
});

const Search = errorBoundary(({ list, setList, tab, index }) => {
    const [value, setValue] = useState('');

    const onChangeHandler = e => {
        const val = e.target.value;
        const data = list.filter(item => {
            if (!val || item.index.indexOf(val) > -1 || item.title.indexOf(val) > -1) return true;

            return false;
        });

        setValue(val);
        setList(data.slice());
    };

    useEffect(
        () => {
            setValue('');
        },
        [tab, index],
    );

    return (
        <div className={styles.search}>
            <input value={value} type="text" placeholder="输入品牌名称 编号 查询" onChange={onChangeHandler} />
            <img src={require('../assets/search.png')} alt="" />
        </div>
    );
});

const Content = errorBoundary(() => {
    const [index, setIndex] = useState(0);
    const [tab, setTab] = useState('0');
    const [activeMenu, setActiveMenu] = useState(menu.slice(0, 7));
    const [allList, setAllList] = useState([]);
    const [list, setList] = useState([]);

    const getData = async () => {
        const res = await getSurveyData(menu[index].id);

        const data = res.data.result[0].resultArray.option.map((item, index) => {
            item.index = index < 9 ? `00${index + 1}` : `0${index + 1}`;
            item.qid = res.data.result[0].resultArray.questionid;
            item.mid = res.data.surveyinfo.id;

            return item;
        });

        setList(data);
        setAllList(data);
    };

    const changeTab = e => {
        const index = e.target.attributes['data-index'].value;

        setTab(index);
    };

    useEffect(
        () => {
            getData();
        },
        [index],
    );

    useEffect(
        () => {
            const tabIndex = parseInt(tab);

            setIndex(tabMenuIndex[tabIndex]);
            setActiveMenu(menu.slice(tabMenuIndex[tabIndex], tabMenuIndex[tabIndex + 1]));
        },
        [tab],
    );

    return (
        <div className={styles.Tab}>
            <div className={styles.top} onClick={e => changeTab(e)}>
                {['全场大奖'].map((item, index) => {
                    return <img key={index} src={require('../assets/tab_title.png')} alt="" />;
                })}
            </div>
            <Menu setIndex={setIndex} index={index} tab={tab} activeMenu={activeMenu} />
            <Search setList={setList} list={allList} index={index} tab={tab} />
            <CardList content={list} />
        </div>
    );
});

const Card = errorBoundary(({ content, index }) => {
    const recordId = `${content.mid}@${content.itemid}`;
    const [data, toggle] = Alerter.useContainer();
    const [voteNum, setNum] = useState(content.num);
    const [voted, setVoted] = useState(votedRecord[recordId]);

    const recordVoted = () => {
        setVoted(true);
        votedRecord[recordId] = num + 1;
    };

    useEffect(() => {
        setNum(votedRecord[recordId] || content.num);
        setVoted(votedRecord[recordId]);
    }, content);

    return (
        <div
            className={styles.card}
            onClick={() =>
                openAlert({
                    id: content.url,
                    title: '作品详情',
                    toggle,
                })
            }>
            <div className={styles.num}>
                <div>{content.index}</div>
            </div>
            <div className={styles.pic}>
                <LazyImg src={formatImage(content.pic_url, 340, 340)} />
            </div>
            <div className={styles.intro}>
                <div className={styles.title}>{content.title}</div>
                <div className={styles.count}>{parseInt(voteNum)}票</div>
                <div
                    className={styles.vote}
                    onClick={async e => {
                        e.stopPropagation();

                        const res = await postSurveyData(`sur[${content.qid}][]=${content.itemid}`, content.mid);

                        alert(res.msg);

                        if (res.ifsuccess) {
                            setNum(num + 1);
                            recordVoted();
                        }
                    }}>
                    <img src={require(`../assets/vote${voted ? 'd' : ''}.png`)} alt="" />
                </div>
            </div>
        </div>
    );
});

const CardList = errorBoundary(({ content }) => {
    if (!content.length)
        return (
            <div className={styles.CardList}>
                <div className={styles.more}>
                    <div>没有更多了</div>
                </div>
            </div>
        );

    const len = useRef(6);
    const allList = useRef(content);

    const [list, setList] = useState(content.slice(0, len.current));
    const [more, setMore] = useState(true);

    const loadMore = () => {
        console.log(allList.current);

        if (len.current < allList.current.length) {
            len.current += 6;
            setList(allList.current.slice(0, len.current));
        } else {
            setMore(false);
        }
    };

    const [ref, entry] = useIntersect({ threshold: 0.5, callback: () => loadMore() });

    useEffect(
        () => {
            allList.current = content;
            setList(content.slice(0, len.current));
            console.log('====', content.slice(0, len.current));
        },
        [content],
    );

    return (
        <div className={styles.CardList}>
            {list.slice().map((item, index) => {
                return <Card key={item.itemid} content={Object.assign({}, item)} index={index + 1} />;
            })}
            <div className={styles.more} ref={ref}>
                {more ? (
                    <div>
                        下滑加载更多<img src={require('../assets/load.png')} />
                    </div>
                ) : (
                    <div>没有更多了</div>
                )}
            </div>
        </div>
    );
});
